export default "__VITE_ASSET__2aea4db1__"